<template>
  <div class="product-list">
    <div class="search">
      <el-input
        size="small"
        placeholder="搜索产品"
        v-model="form.proName"
        class="input-with-select"
        clearable
        @change="getData"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="classify">
      <!-- 1-->
      <!-- 1-->
      <!-- 1-->
      <el-cascader
        v-model="typeId"
        :options="productTypeList"
        :props="Object.assign(treeSelectProps, { expandTrigger: 'hover' })"
        @change="handleChangeType"
        style="width: 49%"
        size="small"
        clearable
        placeholder="请选择分类"
      ></el-cascader>
      <el-select
        style="width: 49%"
        clearable
        size="small"
        v-model="form.vipType"
        @change="getData"
      >
        <el-option key="" label="全部等级" value=""></el-option>
        <template v-for="(value, key) in dictData['vipType']">
          <el-option
            :key="value.value"
            :label="value.label"
            :value="value.value"
          ></el-option>
        </template>
      </el-select>
    </div>
     <div class="classify">
      <el-select
        style="width: 100%"
        clearable
        size="small"
        v-model="form.state"
        @change="getData"
        multiple
        placeholder="请选择所属国家"
      >
        <template v-for="(value, key) in dictData['country_site']">
          <el-option
            :key="value.value"
            :label="value.label"
            :value="value.value"
          ></el-option>
        </template>
      </el-select>
    </div>
    <div class="sort-box">
      <div
        :class="['sort-item', item.value === selectSort ? 'active' : '']"
        v-for="(item, index) in sorts"
        :key="index"
        @click="selectSortFn(item)"
      >
        {{ item.label }}
        <div class="sort-icons">
          <i
            :class="[
              'sort-icon',
              'up',
              'el-icon-caret-top',
              item.value === selectSort ? (selectSortUp ? 'active' : '') : '',
            ]"
          ></i>
          <i
            :class="[
              'sort-icon',
              'down',
              'el-icon-caret-bottom',
              item.value === selectSort ? (selectSortUp ? '' : 'active') : '',
            ]"
          ></i>
        </div>
      </div>

      <el-tooltip
        class="item toolbar-item"
        effect="dark"
        content="重置"
        placement="bottom"
      >
        <span @click="handleReset" class="iconfont iconsort-neat cp"></span>
      </el-tooltip>
    </div>
    <div class="result">
      <div class="result-content">
        <div
          @click="handleClickProduct(record)"
          @mouseover="handlePreviewProduct(index)"
          @mouseout="handleCloseProduct(index)"
          v-for="(record, index) in productList"
          :key="index"
          class="item"
          :class="{ active: record.pId == active }"
        >
          <img
            class="proImg"
            :src="`${record.picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500/quality,q_100`"
          />
          <div class="site">站点 {{ record.state }}</div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          layout="total, prev, next, jumper"
          :total="total"
          :page-size="30"
        >
        </el-pagination>
      </div>
    </div>
    <div
      class="imgPanInfo"
      @mouseenter="handleMouseoverPreview"
      @mouseleave="handleMouseoutPreview"
      v-if="showPreview"
    >
      <div class="imgPanInfoName">
        {{
          productList.length > 0 ? productList[previewProductIndex].proName : ""
        }}
      </div>
      <div class="imgPanInfoStandard">
        <span
          >编号：{{
            productList.length > 0
              ? productList[previewProductIndex].proCode
              : ""
          }}</span
        >
      </div>
      <div class="imgPanInfoDesigner"></div>
      <div class="imgPanInfoBig">
        <img
          width="100%"
          :src="`${productList[previewProductIndex].picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500/quality,q_100`"
        />
      </div>
      <ul class="color-picker-list">
        <li
          v-for="(record, index) in productList[previewProductIndex].mainList"
          :key="index"
        >
          <img
            width="24px"
            :src="`${record.picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500/quality,q_100`"
          />
        </li>
      </ul>
      <div class="imgPanInfoDesc scrollbar"></div>
    </div>
  </div>
</template>

<script>
import { getProductList } from "@/api/customProduct/product"
import { getProductTypeTree } from "@/api/product/type"
import TreeSelect from "@/components/common/treeSelect"

import { mapGetters } from "vuex"

let timer = null

export default {
  name: "ProductList",
  components: { TreeSelect },
  props: {
    saleType: {
      type: String,
      default: "",
    },
    features: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  data() {
    return {
      selectValue: "",
      optionsList: [
        {
          label: "归档图库",
          value: "1",
        },
        {
          label: "我的图库",
          value: "2",
        },
        {
          label: "示例图库",
          value: "3",
        },
      ],
      selectSort: "",
      selectSortUp: true,
      sorts: [
        {
          label: "默认排序",
          value: "sort",
        },
        {
          label: "价格排序",
          value: "price",
        },
        {
          label: "产品销量",
          value: "sales",
        },
      ],
      productList: [],
      currentPage: 1,
      keyword: "",
      classify: [],
      total: 0,
      form: {
        proName: "",
        pageSize: 30,
        pageNum: 1,
        typeId: "",
        saleType: "",
        productType: "01",
        isAsc: "desc",
        orderByColumn: "sort",
        vipType: "",
        state: []
      },
      previewProductIndex: 0,
      showPreview: false,
      isMouseIn: false,
      productTypeList: [],
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      },
      typeId: [],
      active: "",
    }
  },
  methods: {
    selectSortFn(data) {
      this.selectSort = data.value
      this.selectSortUp = !this.selectSortUp
      this.form.orderByColumn = data.value
      this.form.isAsc = this.selectSortUp ? "asc" : "desc"
      this.getData()
    },
    handleCurrentChange(pageNum) {
      this.form.pageNum = pageNum
      this.getData()
    },
    handleChangeClassify() {},
    getData() {
      let form = JSON.parse(JSON.stringify(this.form))
      this.startLoading()
      if (this.features == 0) {
        form.features = "01,03"
      } else {
        form.features = "02,03"
      }
      form.state = form.state.join(",")
      getProductList(form).then((res) => {
        for (let record of res.rows) {
          record.mainList.map((map) => {
            if (map.isMain == "2") {
              record.picUrl = map.picUrl
            }
          })
          if (!record.picUrl) {
            record.picUrl = record.mainList[0].picUrl
          }
        }

        this.productList = res.rows
        this.total = res.total
        this.endLoading()
        this.$emit("loaded", res.rows)
      })
    },
    handlePreviewProduct(index) {
      this.previewProductIndex = index
      this.showPreview = true
      this.isMouseIn = false
      timer ? window.clearTimeout(timer) : ""
      timer = window.setTimeout(() => {
        this.showPreview = false
      }, 1500)
    },
    handleCloseProduct(index) {},
    handleMouseoverPreview() {
      this.isMouseIn = true
      timer ? window.clearTimeout(timer) : ""
    },
    handleMouseoutPreview() {
      if (this.isMouseIn) {
        console.log(1)
        this.isMouseIn = false
        this.showPreview = false
      }
    },
    handleClickProduct(record) {
      this.$emit("add", record)
      this.active = record.pId
    },
    async getProductTypeTree() {
      let result = await getProductTypeTree({ productType: "01", status: 1 })
      result.data.map((record) => {
        record.typeName = `${record.typeName}(${record.proNum})`
        if (record.childrenTree) {
          record.childrenTree.map((item) => {
            item.typeName = `${item.typeName}(${item.proNum})`
            if (item.childrenTree) {
              item.childrenTree.map((menu) => {
                menu.typeName = `${menu.typeName}(${menu.proNum})`
              })
            }
          })
        }
      })
      let data = result.data
      for (let i = 0; i < data.length; i++) {
        if (data[i].proNum == 0) {
          data.splice(i, 1)
          i--
        } else if (data[i].childrenTree) {
          for (let j = 0; j < data[i].childrenTree.length; j++) {
            if (data[i].childrenTree[j].proNum == 0) {
              data[i].childrenTree.splice(j, 1)
              j--
            }
          }
        }
      }
      this.productTypeList = data
    },
    getTreeNodeId(value) {
      this.form.typeId = value
      this.getData()
    },
    handleCommand(command) {
      if (command == "sales") {
        this.form.isAsc = "desc"
        this.form.sortType = "saleNum"
      } else if (command == "default") {
        this.form.isAsc = ""
        this.form.sortType = ""
      }
      this.getData()
    },
    handleReset() {
      this.form = {
        proName: "",
        pageSize: 30,
        pageNum: 1,
        typeId: "",
        saleType: "",
        productType: "01",
        isAsc: "",
        orderByColumn: "",
      }
      this.selectSort = ""
      this.selectSortUp = true
      this.getData()
    },
    handleChangeType(value) {
      this.form.typeId = value[value.length - 1]
      this.getData()
    },
  },
  mounted() {
    this.getData()
    this.getProductTypeTree()
  },
}
</script>

<style lang="scss" scoped>
.product-list {
  position: relative;
  height: 100%;
}

.classify {
  display: flex;
  justify-content: space-between;
}

.sort-box {
  width: calc(100% - 8px);
  height: 32px;
  background: #0000000a;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 16px;
  margin-right: 20px;

  .sort-item {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.active {
      color: #4934b2 !important;
    }

    .sort-icons {
      line-height: 7px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .sort-icon {
        color: #ccc;
        line-height: 7px;

        &.active {
          color: #4934b2 !important;
        }
      }
    }
  }
}

.productPanInfo,
.imgPanInfo {
  position: fixed;
  width: 240px;
  left: 392px;
  top: 173px;
  background: #ffffff;
  box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px 0 rgb(0 0 0 / 8%),
    0 3px 6px -4px rgb(0 0 0 / 12%);
  border-radius: 2px;
  padding: 10px 10px;
  color: rgb(77, 77, 77);
  overflow: hidden;
  z-index: 99;
  line-height: 24px;

  .imgPanInfoStandard {
    font-size: 12px;
    color: #aaaaaa;
    margin: 0 0 5px 0;
  }
  .color-picker-list {
    overflow: hidden;
    margin-left: -4px;
  }
  .color-picker-list li,
  .color-picker-list-hover li,
  .mgg-preview-colors li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }

  .color-picker-list li.cur,
  .mgg-preview-colors li.cur {
    border: rgb(236, 78, 43) solid 2px;
  }

  .color-picker-list li a,
  .color-picker-list-hover li a,
  .mgg-preview-colors li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.search ::v-deep .el-input-group__append {
  background-color: transparent;
}
.el-dropdown-link {
  cursor: pointer;
  color: #4934b2;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.site {
    position: absolute;
    right: 4px;
    bottom: 4px;
    height: 20px;
    padding: 0 5px;
    line-height: 19px;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    display: block;
    background: #aaaaaa;
}
</style>
